import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import EmployeeCard from './EmployeeCard.jsx';

type EmployeeRecord = Record<string, unknown> & { id: string | number };

interface DirectoryGridSectionProps {
  title: string;
  subtitle?: string;
  employees: EmployeeRecord[];
  onEmployeeSelect: (employee: EmployeeRecord) => void;
}

export default function DirectoryGridSection({ title, subtitle, employees, onEmployeeSelect }: DirectoryGridSectionProps) {
  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <div>
          <div style={{ color: C.text, fontSize: 16, fontWeight: 600 }}>{title}</div>
          {subtitle ? <div style={{ color: C.textMuted, fontSize: 12, marginTop: 4 }}>{subtitle}</div> : null}
        </div>
        <span style={{ fontSize: 11, color: C.gold, background: 'rgba(201,162,39,0.12)', padding: '4px 10px', borderRadius: 999 }}>
          {employees.length}
        </span>
      </div>

      {employees.length === 0 ? (
        <div style={{ color: C.textMuted, fontSize: 13 }}>No employees in this section.</div>
      ) : (
        <div style={{ display: 'grid', gap: 10 }}>
          {employees.map((employee) => (
            <EmployeeCard key={employee.id} employee={employee} onClick={onEmployeeSelect} />
          ))}
        </div>
      )}
    </div>
  );
}
